import MarkdownIt from 'markdown-it';

// 初始化 markdown-it（配置可自定义）
const md = new MarkdownIt({
  html: false, // 不解析 HTML
  breaks: true, // 依赖规则保留换行
  linkify: true, // 自动识别链接
});

export const markdown2Text = (markdownText: string): string => {
  const html = md.render(markdownText);
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const extractTextChildren = (node: Node): string => {
    return (
      Array.from(node.childNodes)
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        .map((child) => extractText(child))
        .join('')
    );
  };

  const extractText = (node: Node): string => {
    // 处理文本节点
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent?.replace(/\s+/g, ' ') || ''; // 合并连续空格
    }

    const el = node as HTMLElement;
    const tagName = el.tagName.toUpperCase();
    let content = '';

    // 特殊标签处理
    switch (tagName) {
      case 'BR':
        return '\n'; // 直接返回换行符
      case 'IMG':
        return el.getAttribute('alt')?.trim() + ' ' || '';
      case 'A':
        return extractTextChildren(el) + ' ';
    }

    // 递归处理子节点
    content = extractTextChildren(el);

    // 块级元素处理
    if (
      [
        'P',
        'DIV',
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6',
        'UL',
        'OL',
        'LI',
        'PRE',
        'HR',
        'BLOCKQUOTE',
      ].includes(tagName)
    ) {
      return '\n' + content.trim() + '\n';
    }

    return content;
  };

  // 最终文本处理
  return extractText(doc.body)
    .replace(/(\n\s*){2,}/g, '\n\n') // 合并多个空行
    .replace(/ +\n/g, '\n') // 清理行尾空格
    .replace(/\n /g, '\n') // 清理行首空格
    .trim();
};
